import { render } from "./ModalScheduledBulkCampaign.vue?vue&type=template&id=4b4494be"
import script from "./ModalScheduledBulkCampaign.vue?vue&type=script&lang=ts"
export * from "./ModalScheduledBulkCampaign.vue?vue&type=script&lang=ts"

import "./ModalScheduledBulkCampaign.vue?vue&type=style&index=0&id=4b4494be&lang=scss"
script.render = render

export default script